// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customContainer[data-v-1dea8a66]{width:100%;height:64px;display:grid;grid-template-rows:100%;grid-template-columns:calc(100% - 52px) 52px;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
